import moment from 'moment';

import {
  getTotalFixedPricesPerDay,
  getTotalFuturePrices
} from 'utils/book-accommodation-and-activity/totalPrice';

const getAddOns = (bookItem, currency) => {
  if (!bookItem.addOns || !bookItem.addOns.length) return {};

  return {
    addOns: bookItem.addOns
      .map(item => {
        if (!item.value || !parseInt(item.value)) return;
        const totalPrice = `${item.value * item[currency]}`;
        const originalIdObj = item.originalId ? { id: item.originalId } : {};
        return {
          ...originalIdObj,
          addOnId: item.id,
          currency: currency,
          addOnCount: parseInt(item.value),
          totalPrice: parseFloat(totalPrice.split(',').join(''))
        };
      })
      .filter(item => item)
  };
};

const getMandatoryFees = (bookItem, currency) => {
  if (!bookItem.mandatoryFees || !bookItem.mandatoryFees.length) return {};

  return {
    mandatoryFees: bookItem.mandatoryFees
      .map(item => {
        // if (!item.value || !parseInt(item.value)) return;
        const totalPrice = `${item[currency]}`;
        const originalIdObj = item.originalId ? { id: item.originalId } : {};
        return {
          ...originalIdObj,
          mandatoryFeeId: item.id,
          currency: currency,
          mandatoryFeeCount: parseInt(0),
          totalPrice: parseFloat(totalPrice.split(',').join(''))
        };
      })
      .filter(item => item)
  };
};

const getGuests = (bookItem, pricesType, currency, isAccommodation) => {
  if (!bookItem.participants || !bookItem.participants.length) return {};

  return {
    guests: bookItem.participants
      .map(item => {
        if (!item.participants || !parseInt(item.participants)) return;
        let totalPrice = `${item.participants * item[currency]}`;
        if (
          (bookItem.accommodationId || isAccommodation) &&
          pricesType === 'pricesDailyForm'
        ) {
          totalPrice = `${item[currency]}`;
        } else if (bookItem.pricesType === 'futurePricesForm') {
          totalPrice += getTotalFuturePrices(item.dates, item, currency);
        } else if (
          pricesType === 'pricesFixedForm' ||
          pricesType === 'pricesCategoryForm'
        ) {
          if (
            bookItem.dates &&
            bookItem.dates.startDate &&
            bookItem.dates.endDate
          ) {
            const isParticipants = pricesType === 'pricesCategoryForm';
            totalPrice = `${getTotalFixedPricesPerDay(
              bookItem.dates,
              item[currency],
              item,
              isParticipants,
              isAccommodation,
              pricesType
            )}`;
          } else {
            totalPrice = item[currency];
          }
        }
        return {
          participant: item.participant,
          guestsNumber: parseInt(item.participants),
          totalPrice: parseFloat(totalPrice.split(',').join(''))
        };
      })
      .filter(item => item)
  };
};

const getStartingDate = bookItem => {
  if (!bookItem.startingDate && !bookItem.multiDates) return {};
  if (!bookItem.startingDate)
    return {
      startingDate: moment(bookItem.multiDates.startDate).format('YYYY-MM-DD'),
      endingDate: bookItem.multiDates.endDate ? moment(bookItem.multiDates.endDate).format('YYYY-MM-DD') : null
    };
  else
    return {
      startingDate: moment(bookItem.startingDate).format('YYYY-MM-DD')
    };
};

const getSchedule = bookItem => {
  if (!bookItem.startTime) return {};

  return {
    schedule: {
      startTime: moment(bookItem.startTime.startTime, 'HH:mm').format(
        'HH:mm:ssZZ'
      ),
      duration: parseInt(bookItem.startTime.duration),
      timeType: bookItem.startTime.timeType
    }
  };
};

export { getAddOns, getMandatoryFees, getGuests, getStartingDate, getSchedule };
